exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*--------------- Start Error Modal----------*/\r\n\r\n#error-modal {\r\n    top: 25%;\r\n}\r\n\r\n#error-modal .modal-dialog {\r\n    width: 355px;\r\n}\r\n\r\n#error-modal .modal-content {\r\n    height: 185px;\r\n    border-radius: 0px;\r\n}\r\n\r\n#error-modal .modal-body {\r\n    text-align: center;\r\n    font-size: 16px;\r\n    height: 100%;\r\n    padding-top: 28px;\r\n}\r\n\r\n#error-modal .modal-header {\r\n    text-align: center;\r\n    color: #0071bc;\r\n    font-size: 22px;\r\n    background-color: #eeeeee;\r\n    line-height: 20px;\r\n}\r\n\r\n#error-modal .modal-btns {\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 15px;\r\n}\r\n\r\n.hide {\r\n    display: none;\r\n}\r\n\r\n.show {\r\n    display: block;\r\n}\r\n\r\n#error-modal .close {\r\n    visibility: visible;\r\n}\r\n\r\n#error-modal .btn-hide {\r\n    display: none;\r\n}\r\n\r\n\r\n/*--------------- End Error Modal----------*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/shared-popup/shared-popup.component.css
// module id = 1082
// module chunks = 0